import React from "react";
import {SearchForm} from "./searchForm"
import UserList from "./userList"

const User = () => {
    return (
        <>
            <SearchForm/>
            <UserList/>
        </>
    )
}
export default User